import { ImagePlus } from "lucide-react";
import { Leaf } from "./Leaf";

export function PhotoSlot({ label, className = "", testId }: { label: string; className?: string; testId?: string }) {
  return (
    <div data-testid={testId} className={`relative grid place-items-center overflow-hidden bg-cream-sand ${className}`}>
      <div className="absolute inset-3 rounded-[inherit] border border-dashed border-gold/60" />
      <Leaf className="absolute -right-6 -top-6 h-32 w-32 rotate-45 text-forest/[0.06]" />
      <div className="relative flex flex-col items-center gap-3 px-6 text-center">
        <span className="grid h-12 w-12 place-items-center rounded-full bg-cream text-gold-ink ring-1 ring-gold/40"><ImagePlus className="h-5 w-5" /></span>
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-charcoal-soft">{label}</span>
      </div>
    </div>
  );
}
